export default "__VITE_ASSET__4407a699__"